var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('VueRecaptcha',{ref:"recaptcha",attrs:{"id":"g-recaptcha","sitekey":_vm.sitekey,"loadRecaptchaScript":true},on:{"verify":_vm.validate,"expired":_vm.onCaptchaExpired}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }